<template>
  <div>
    <el-image v-if="photoUrlList && photoUrlList.length > 0"
              :preview-src-list="photoUrlList"
              v-for="(item, index) in photoUrlList"
              :fit="fit"
              :src="item"
              :initial-index="index"
    >
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"
           style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
      </div>
    </el-image>
    <el-image v-else>
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"
           style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
      </div>
    </el-image>
  </div>
</template>

<script>

export default {
  name: 'multiplePhotoShow',
  props: {
    photoUrlList: {
      type: [Array],
      require: true
    },
  },

  computed: {

  },

  components: {

  },

  data() {
    return {
      style: {
        marginRight: this.interval
      }
    }
  },

  watch: {


  },


  methods: {

  },
};
</script>

<style scoped lang="scss">

</style>
